import React, { Component } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { get } from 'lodash';
import moment from 'moment';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { G90_DEEP_LINKING } from 'constants/capabilities';
import WorkOrderChannelView from 'components/organisms/entity/view/WorkOrderChannelView';
import WorkOrderIdViewLink from 'containers/entity/workOrder/WorkOrderIdViewLink';

const ADMIN_PLATFORM_MAP = {
    ccms: 'Job Number',
    salesforce: 'Salesforce Opportunity',
};

const ADMIN_PLATFORM_TITLE_MAP = {
    ccms: 'CCMS',
    salesforce: 'Campaign Engine',
};

const ADMIN_PLATFORM_FIELD_MAP = {
    ccms: 'jobNumber',
    salesforce: 'salesforceId',
};

const WorkOrder = styled.div`
    border: 1px solid ${props => props.theme.colors.darkgray};
    margin-top: 20px;
    padding: 10px;
    font-size: 14px;
    color: #656158;

    :hover {
         box-shadow: 0 4px 6px rgba(0,0,0,0.10), 0 4px 6px rgba(0,0,0,0.10);
         border: 1px solid #007DC6;

    }
`;

const FlexWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const ProtectedWorkOrderIdLink = ProtectedComponent({
    requiredCapabilities: [G90_DEEP_LINKING],
    NoAccessComponent: props => props.workOrderId
})(WorkOrderIdViewLink);

class WorkOrderView extends Component {
    getAdminPlatform() {
        return get(this.props.workOrder, 'adminPlatform', null);
    }

    getAdminPlatformFromMap(MAP) {
        const adminPlatform = this.getAdminPlatform();
        if (adminPlatform) {
            return MAP[adminPlatform];
        }

        // this should never hit, here for development
        return 'Invalid Platform';
    }

    render() {
        const { entity = {}, workOrder = {}, expanded = false } = this.props;
        const entityBrand = get(entity, 'Brand.name', null);
        const startDate = get(workOrder.meta, 'startDate', null);
        const endDate = get(workOrder.meta, 'endDate', null);
        const description = get(workOrder.meta, 'description', null);

        return (
            <Row>
                <Col xs={12}>
                    <WorkOrder>
                        <Row>
                            <Col xs={6}><strong>{this.getAdminPlatformFromMap(ADMIN_PLATFORM_MAP)}</strong></Col>
                            <Col xs={6}><strong>Admin Platform</strong></Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <ProtectedWorkOrderIdLink
                                    adminPlatform={this.getAdminPlatform()}
                                    workOrderId={this.props.workOrder[
                                        this.getAdminPlatformFromMap(ADMIN_PLATFORM_FIELD_MAP)
                                    ]}
                                />
                            </Col>
                            <Col xs={6}>{this.getAdminPlatformFromMap(ADMIN_PLATFORM_TITLE_MAP)}</Col>
                        </Row>
                        {description ? (
                            <React.Fragment>
                                <Row>
                                    <Col xs={5}><strong>Description</strong></Col>
                                </Row>
                                <Row>
                                    <Col style={{ 'line-height': '20px', 'margin-bottom': '10px' }} xs={6}>{description}</Col>
                                </Row>
                            </React.Fragment>
                        ) : null}
                        { (startDate || endDate) ? (
                            <React.Fragment>
                                <Row>
                                    <Col xs={6}>
                                        <FlexWrapper>
                                            <strong>Effective Start Date</strong>
                                        </FlexWrapper>
                                    </Col>
                                    <Col xs={5}>
                                        <FlexWrapper>
                                            <strong>Effective End Date</strong>
                                        </FlexWrapper>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={6}>{startDate ? moment(startDate).format('MM-DD-YYYY') : 'No Date Set' }</Col>
                                    <Col xs={6}>{endDate ? moment(endDate).format('MM-DD-YYYY') : 'No Date Set' }</Col>
                                </Row>
                            </React.Fragment>
                        ) : null}
                        <WorkOrderChannelView
                            workOrder={workOrder} brand={entityBrand} expanded={expanded} />
                    </WorkOrder>
                </Col>
            </Row>
        );
    }
}

export default WorkOrderView;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/view/WorkOrderView.js